import { useState, useEffect, useLayoutEffect, useContext } from "react";
import { AppContext } from "../App";

export default function useDOP() {
  const { location } = useContext(AppContext);
  const [popupVisible, setPopupVisible] = useState(false);
  const [year, setYear] = useState("2024");

  useLayoutEffect(() => {
    const hcpPopup = document.querySelector(".hcp-popup-header");

    if (hcpPopup) {
      setPopupVisible(true);
    } else {
      setPopupVisible(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (popupVisible) {
      setYear("2024");
    } else {
      switch (location.pathname) {
        case "/hcp/resources":
          setYear("2025");
          break;

        default:
          setYear("2025");
          break;
      }
    }
  }, [popupVisible, location.pathname]);

  return year;
}
